import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { VectorShape } from '../shape';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip2d } from './utils';
var shape = {
  vector: VectorShape
};
/**
 * Convert value for each channel to start, end.
 * The angle starts from the X axis(right direction).
 */
export var Vector = function Vector() {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      Y = value.y,
      S = value.size,
      R = value.rotate;
    var _coordinate$getSize = coordinate.getSize(),
      _coordinate$getSize2 = _slicedToArray(_coordinate$getSize, 2),
      width = _coordinate$getSize2[0],
      height = _coordinate$getSize2[1];
    var P = index.map(function (i) {
      var angle = +R[i] / 180 * Math.PI;
      var s = +S[i];
      var a = s / width;
      var b = s / height;
      var vx = a * Math.cos(angle);
      var vy = -b * Math.sin(angle);
      return [coordinate.map([+X[i] - vx / 2, +Y[i] - vy / 2]), coordinate.map([+X[i] + vx / 2, +Y[i] + vy / 2])];
    });
    return [index, P];
  };
};
Vector.props = {
  defaultShape: 'vector',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    required: true
  }, {
    name: 'y',
    required: true
  }, {
    name: 'rotate',
    required: true,
    scale: 'identity'
  }, {
    name: 'size',
    required: true
  }]),
  preInference: _toConsumableArray(basePreInference()),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip2d()))
};